import actions from '../../actionTypes';

export default siteUserId => {
  return {
    type: actions.REMOVE_SITE_USER_SUCCESS,
    siteUserId
  };
};



// WEBPACK FOOTER //
// ./src/reducers/users/actions/removeSiteUserSuccess.js